export default __webpack_public_path__ + "static/media/about.9060f794.png";